import React, { useRef } from 'react';
import ExploreSubCatProducts from '../../CategoryDetail/L1CategoryPage/ExploreSubCatProducts/ExploreSubCatProducts';
import RelatedCategoryNavigator from '../../CategoryDetail/RelatedCategoryNavigator/RelatedCategoryNavigator';
import StickySubCategory from '../../CategoryDetail/StickySubCategory/StickySubCategory';
import CarouselNew from '../../NewStoreHomeWeb/CarouselNew/CarouselNew';
import ScrollWrapper from '../../ScrollWrapper/ScrollWrapper';
import BannerCategoryPage from './BannerCategoryPage';
import BannerVideo from './BannerVideo';
import CategoryFaqsData from './CategoryFaqsData/CategoryFaqsData';
import DiaperSizeVariants from './DiaperSizeVariants';
import HorizontalVideoSection from './HorizontalVideoSection/HorizontalVideoSection';
import MarqueeCategoryPage from './MarqueCategoryPage';
import MultiCategorySection from './MultiCategorySection';
import { GeneralItemCover } from './styled';

function CategoryGeneralItemsListing(props) {
  const {
    generalItems,
    categoryWrapHeight,
    filterRef,
    showHeader,
    categoryId,
    location,
    isL1Category,
    pageTitle,
    pageDesc,
  } = props;
  const bottomRef = useRef();
  const getGeneralItem = (item, index) => {
    const itemType = item?.itemType;
    switch (itemType) {
      case 'MULTIPLE_ITEMS':
        const viewType = item?.viewType;
        switch (viewType) {
          case 'MANUAL_CAROUSEL':
          case 'CAROUSEL_DOTS':
            return <BannerCategoryPage data={item} index={index} />;
          case 'LINEAR':
            return (
              <ExploreSubCatProducts
                data={[item]}
                categoryId={categoryId}
                isL1Category={isL1Category}
                generalItemIndex={index}
              />
            );
            break;

          case 'GRID':
            const firstItemType = item?.items?.[0]?.itemType;
            switch (firstItemType) {
              case 'BANNER':
                return (
                  <MultiCategorySection categoryId={categoryId} data={item} />
                );
              case 'PRODUCT':
                return (
                  <ExploreSubCatProducts
                    categoryId={categoryId}
                    data={[item]}
                    isL1Category={isL1Category}
                    generalItemIndex={index}
                  />
                );
            }
            break;

          case 'HORIZONTAL':
            return (
              <ExploreSubCatProducts
                data={[item]}
                horizontal={true}
                categoryId={categoryId}
                isL1Category={isL1Category}
                generalItemIndex={index}
              />
            );
            break;
        }
        break;
      case 'SMART_CATEGORIES_NEW':
        return (
          <StickySubCategory
            categoryWrapHeight={categoryWrapHeight}
            filterRef={filterRef}
            filtersData={item}
            showHeader={showHeader}
            categoryId={categoryId}
            generalItems={generalItems}
            bottomRef={bottomRef}
          />
        );

      case 'MARQUEE_BANNERS':
        return (
          <MarqueeCategoryPage
            data={item}
            mobileGap={'1rem'}
            desktopGap={'2rem'}
            pageTitle={pageTitle}
            pageDesc={pageDesc}
          />
        );
      case 'MARQUEE_STRIP':
        return (
          <MarqueeCategoryPage
            pageTitle={pageTitle}
            pageDesc={pageDesc}
            isStripItem={true}
            data={item}
          />
        );
      case 'CHOOSE_SIZE_PRODUCTS':
        return (
          <DiaperSizeVariants variantData={item} categoryId={categoryId} />
        );
      case 'BANNER':
        return (
          <BannerCategoryPage
            data={item}
            index={index}
            isL1Category={isL1Category}
          />
        );
      case 'AUTO_PLAY_VIDEO':
        return (
          <BannerVideo
            videoData={item?.videoUrlData}
            itemId={item?._id}
            key={`element-${index}`}
            index={index}
            autoPlay={1}
            location={location}
            contentData={item?.contentData}
          />
        );
      case 'CATEGORY_DISCUSSIONS':
        return <CategoryFaqsData data={item} />;
      case 'L1_CATEGORY_PAGE_NAVIGATOR':
        return <RelatedCategoryNavigator categoryId={categoryId} data={item} />;
      case 'GENERAL_HORIZONTAL_VIDEO_SECTION':
        return <HorizontalVideoSection categoryId={categoryId} data={item} />;
      case 'TESTIMONIALS':
        return <CarouselNew newReviews={true} testimonialData={item?.items} />;
    }
  };
  const getDataForEvent = (item) => {
    let data = {};
    data['category'] = 'impression_section_in_general_screen';
    data['section_name'] = item?.itemName || item?.heading;
    data['section_id'] = item?._id;
    data['id'] = categoryId;
    data['section_title'] = item?.heading || '';

    if (item.itemType === 'AUTO_PLAY_VIDEO') {
      data['section_name'] = 'Video';
    }
    if (item.itemType === 'BANNER') {
      data['section_name'] = 'Banner';
    }

    return data;
  };
  return (
    <GeneralItemCover>
      {/* <L2BannerComponent /> */}
      {generalItems?.map((item, index) => {
        const eventData = getDataForEvent(item);
        return (
          <ScrollWrapper
            data={eventData}
            threshold={0.2}
            key={'generalItem' + index}
            contentDisplay={item?.isFilterItem}
            outerRef={item?.isFilterItem ? filterRef : null}
          >
            {getGeneralItem(item, index)}
          </ScrollWrapper>
        );
      })}
      <div id="bottomRef"></div>
    </GeneralItemCover>
  );
}

export default CategoryGeneralItemsListing;
